import { SectionHeading } from '@atlassian/mpac-ui';
import React from 'react';
import { Section, SectionsWrapper } from '../../../Section';
import InstallationSteps from './InstallationSteps';
const InstallationTab = props => {
  return /*#__PURE__*/React.createElement(SectionsWrapper, {
    "data-testid": "installation-section"
  }, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(SectionHeading, null, "Installation"), /*#__PURE__*/React.createElement(InstallationSteps, props)));
};
export default InstallationTab;